<template>
  <panel class="procedure-generate" title="Generowanie dokumentacji">
    <div class="form-group">
      <label for="view">Wybierz szablon</label>

      <select id="view" v-model="selectedView" class="form-control">
        <option v-for="view in views" :key="'view_' + view.id" :value="view.id">
          {{ view.name }}
        </option>
      </select>
    </div>

    <w-input :model="$schema.caseId" @input="loadDocumentName($schema.caseId.$model, 'mdok/getCaseName')" />

    <p v-if="caseName">
      Wybrano sprawę: <b>{{ caseName }}</b>
    </p>

    <div class="procedure-generate-row">
      <schema-form v-if="loadedSchema && schema" :template-name="$schema.$title" :schema="$schema" />
    </div>

    <div slot="footer">
      <post-form
        class="mr-2"
        icon="fal fa-cloud-download mr-2"
        button-class="btn-info"
        text="Pobierz pdf"
        :disabled="postFormsDisabled"
        :fields="viewFormFields"
        :url="pdfUrl"
      />

      <w-button class="btn-primary float-right" text="Prześlij do MDOK" @click="sendToMDOK" />
    </div>
  </panel>
</template>

<script>
import SchemaForm from '@/components/forms/SchemaForm';
import Panel from '@/components/panel/Panel';
import PostForm from '@/components/postForm/PostForm';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { TableName } from '@/enums/tableName';
import { formMixin } from '@/mixins/form';
import { generateMixin } from '@/mixins/generate';
import { mdokDocumentMixin } from '@/mixins/mdokDocument';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/procedureGenerate.schema';
import { config } from '@/utils/config';
import { tryParseInt } from '@/utils/number';

// @vuese
// Generowanie załączników
// @group Procedure
export default {
  name: 'ProcedureGenerate',
  components: { SchemaForm, Panel, PostForm },
  mixins: [formMixin, generateMixin, mdokDocumentMixin, notificationsMixin],
  schema,
  data() {
    return {
      selectedView: tryParseInt(this.$route.params.viewId) || tryParseInt(this.$route.query.viewId),
      entityType: TableName.procedure
    };
  },
  computed: {
    // Identyfikator dokumentu
    procedureId() {
      return this.$route.params.procedureId;
    },

    // Aktualnie wybrany widok
    view() {
      if (this.selectedView) {
        return this.views.find(view => view.id === this.selectedView);
      }
      return this.views[0];
    },

    // Adres do pobrania PDF z wygenerowanym załącznikiem
    pdfUrl() {
      return `${config.renderURL}/pdf/procedure/${this.procedureId}/${this.view.id}`;
    }
  },

  watch: {
    // Ustawia query odpowiednie dla wybranego widoku
    selectedView(viewId) {
      this.$router.replace({ name: this.$route.name, query: { viewId } });
    },

    // Przeładowuje schemę po zmianie wybranego widoku
    view() {
      this.loadedSchema = false;
      this.loadSchema();
    }
  },
  mounted() {
    if (!this.selectedView) {
      this.selectedView = this.views[0].id;
    }
  },
  methods: {
    // @vuese
    // Przesyła załącznik do MDOK
    sendToMDOK() {
      this.save('view/sendGroupToMDOK');
    },

    // @vuese
    // Zapis załącznika
    save(action) {
      const data = this.$schema.$getData();
      this.$store
        .dispatch(action, {
          caseId: data.caseId,
          data,
          procedureId: tryParseInt(this.procedureId),
          viewId: this.view.id
        })
        .then(() => this.notifySuccess(Successes.ATTACHMENT_SAVED))
        .catch(err => this.notifyError(Errors.ERROR_TRY_AGAIN_LATER));
    },

    // @vuese
    // Ładuje schemę
    loadSchema() {
      this.model = {};
      if (this.schema) {
        this.$setSchema({ allOf: [this.schema, schema] });
      } else {
        this.$setSchema(schema);
      }
      this.loadedSchema = true;
    }
  }
};
</script>

<style>
.procedure-generate .procedure-generate-row .btn {
  font-weight: 700;
  text-transform: uppercase;
}
.procedure-generate .procedure-generate-row .modal .btn {
  font-weight: none;
  text-transform: none;
}
</style>
